import { Components } from '../../../styles';
import * as tokens from '@utmost.co/utmost-design-tokens';
import { ELEVATION } from './commons';
import { tokenToPx } from './getToken';

export const paperTheme = {
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundColor: tokens.colorSurface,
        color: tokens.colorOnSurface,
        '&.MuiPopover-paper, &.MuiAutocomplete-paper': {
          ...ELEVATION.level2,
          borderRadius: tokens.radiusDefault,
          fontSize: tokenToPx('bodyMediumFontSize'),
          border: tokens.colorSurfaceVariant
        }
      }
    }
  }
} satisfies Components;
